import styled from "styled-components"

export const StyledError = styled.div`
  color: ${({ theme }) => theme.colors.error};
`
